import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminProductWorksProductWorkRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ product_work_id }) {
    const { content } = await this.store.request(
      findRecord('product-work', product_work_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
